import { Button, Card, CircularProgress, Grid, IconButton, InputLabel, Tooltip } from '@material-ui/core';
import { AddRounded, DeleteRounded, InfoOutlined, VisibilityOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Swal from 'sweetalert2';

import { ModalPreviewSec, UploadImage } from '../../../components';
import { getGlobalData, updGCGContent } from '../../../redux/actions/GlobalActions';

const Konten = () => {
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPreviewSec, setShowPreviewSec] = useState(null)
  const [params, setParams] = useState({
    section_1: {
      title_id: "",
      title_en: "",
      subtitle_id: "",
      subtitle_en: "",
      desc_id: "",
      desc_en: "",
      img_preview: "",
      img_ori: "",
    },
    section_2: {
      img_preview: "",
      img_ori: "",
      list: [],
      relation_guides_title_id: "",
      relation_guides_title_en: "",
    },
    section_3: {
      relation_principle_title_id: "",
      relation_principle_title_en: "",
      list: [],
    },
  });
  const handleChangeSection1 = ({ target: { value, name } }) => {
    let data = params.section_1;
    setParams((pref) => ({
      ...pref,
      section_1: {
        ...data,
        [name]: value,
      },
    }));
  };
  const handleChangeSection2 = ({ target: { value, name } }) => {
    let data = params.section_2;
    setParams((pref) => ({
      ...pref,
      section_2: {
        ...data,
        [name]: value,
      },
    }));
  };
  const handleChangeSection3 = ({ target: { value, name } }) => {
    let data = params.section_3;
    setParams((pref) => ({
      ...pref,
      section_3: {
        ...data,
        [name]: value,
      },
    }));
  };
  const handleChangeListSection2 = ({ target: { value, name } }, index) => {
    let data = params.section_2;
    data.list[index][name] = value;

    setParams((pref) => ({
      ...pref,
      section_2: {
        ...data,
      },
    }));
  };
  const handleChangeListSection3 = ({ target: { value, name } }, index) => {
    let data = params.section_3;
    data.list[index][name] = value;

    setParams((pref) => ({
      ...pref,
      section_3: {
        ...data,
      },
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    updGCGContent(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    });
  };
  const getData = () => {
    setLoading(true);
    getGlobalData()
      .then((res) => {
        let data = res.data?.data;
        if (Object.keys(data).length > 0) {
          setParams((pref) => ({
            ...pref,
            section_1: {
              title_id: data?.section_1?.title_id,
              title_en: data?.section_1?.title_en,
              subtitle_id: data?.section_1?.subtitle_id,
              subtitle_en: data?.section_1?.subtitle_en,
              desc_id: data?.section_1?.desc_id,
              desc_en: data?.section_1?.desc_en,
              img_preview: data?.section_1?.img,
              img_ori: data?.section_1?.img_ori,
            },
            section_2: {
              img_preview: data?.relation_guides_img,
              img_ori: data?.relation_guides_img_ori,
              list: data?.guides,
              relation_guides_title_id: data?.relation_guides_title_id,
              relation_guides_title_en: data?.relation_guides_title_en,
            },
            section_3: {
              img_preview: data?.relation_principle_img,
              img_ori: data?.relation_principle_img_ori,
              relation_principle_title_id: data?.relation_principle_title_id,
              relation_principle_title_en: data?.relation_principle_title_en,
              list: data?.manage,
            },
          }));
        } else {
          showAlert("Gagal mengambil data, coba beberapa saat lagi", false);
        }
        setLoading(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal mengambil data, coba beberapa saat lagi",
          false
        );
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  const handleChangeFotoSection1 = (file, path) => {
    let data = params.section_1;
    data.img_preview = path;
    data.img = file;

    setParams((pref) => ({
      ...pref,
      section_1: data,
    }));
  };

  const handleChangeFotoSection2 = (file, path) => {
    let data = params.section_2;
    data.img_preview = path;
    data.img = file;

    setParams((pref) => ({
      ...pref,
      section_2: data,
    }));
  };

  const handleChangeFotoSection3 = (file, path) => {
    let data = params.section_3;
    data.img_preview = path;
    data.img = file;

    setParams((pref) => ({
      ...pref,
      section_3: data,
    }));
  };

  const addListSection2 = () => {
    let data = params.section_2;
    let newData = {
      idx: Math.floor(Math.random() * 10000),
      title_id: "",
      title_en: "",
    };
    data.list.push(newData);

    setParams((pref) => ({
      ...pref,
      section_2: data,
    }));
  };

  const addListSection3 = () => {
    let data = params.section_3;
    let newData = {
      idx: Math.floor(Math.random() * 10000),
      title_id: "",
      title_en: "",
    };
    data.list.push(newData);

    setParams((pref) => ({
      ...pref,
      section_3: data,
    }));
  };

  const deleteListSection2 = (idx) => {
    let data = params.section_2;
    let newList = data.list.filter((item) => item.idx !== idx);
    data.list = newList;

    setParams((pref) => ({
      ...pref,
      section_2: data,
    }));
  };

  const deleteListSection3 = (idx) => {
    let data = params.section_3;
    let newList = data.list.filter((item) => item.idx !== idx);
    data.list = newList;

    setParams((pref) => ({
      ...pref,
      section_3: data,
    }));
  };
  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">GCG - Konten</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="p-5">
            {loading ? (
              <div className="text-center">
                <CircularProgress color="primary" size={35} />
              </div>
            ) : (
              <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
                <h4 className="fw-bold mb-5">Bagian 1 <IconButton onClick={() => setShowPreviewSec("/assets/images/illustrations/gcg_1.png")} size='small'><VisibilityOutlined fontSize='small' color='action'></VisibilityOutlined></IconButton></h4>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <UploadImage
                      uploadFoto={handleChangeFotoSection1}
                      label="Unggah Foto"
                      preview={params?.section_1?.img_preview}
                      required={true}
                      aspectRatio={544 / 676}
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 544 x 676",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="title_id" className="mb-4">
                      Judul [ID] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="title_id"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChangeSection1}
                      type="text"
                      name="title_id"
                      value={params?.section_1?.title_id || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="title_en" className="mb-4">
                      Judul [EN] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="title_en"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChangeSection1}
                      type="text"
                      name="title_en"
                      value={params?.section_1?.title_en || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="desc_id" className="mb-4">
                      Deskripsi [ID] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="desc_id"
                      placeholder="desckripsi"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChangeSection1}
                      type="text"
                      name="desc_id"
                      value={params?.section_1?.desc_id || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan desckripsi terlebih dahulu"]}
                      multiline
                      maxRows={16}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="desc_en" className="mb-4">
                      Deskripsi [EN] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="desc_en"
                      placeholder="deskripsi"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChangeSection1}
                      type="text"
                      name="desc_en"
                      value={params?.section_1?.desc_en || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan deskripsi terlebih dahulu"]}
                      multiline
                      maxRows={16}
                    />
                  </Grid>
                </Grid>

                <h4 className="fw-bold mb-5 mt-10">Bagian 2<IconButton onClick={() => setShowPreviewSec("/assets/images/illustrations/gcg_2.png")} size='small'><VisibilityOutlined fontSize='small' color='action'></VisibilityOutlined></IconButton></h4>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <UploadImage
                      uploadFoto={handleChangeFotoSection2}
                      label="Unggah Foto"
                      preview={params?.section_2?.img_preview}
                      required={true}
                      aspectRatio={1440 / 506}
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 1440 x 506",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="relation_guides_title_id"
                      className="mb-4"
                    >
                      Judul [ID] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="relation_guides_title_id"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChangeSection2}
                      type="text"
                      name="relation_guides_title_id"
                      value={params?.section_2?.relation_guides_title_id || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="relation_guides_title_en"
                      className="mb-4"
                    >
                      Judul [EN] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="relation_guides_title_en"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChangeSection2}
                      type="text"
                      name="relation_guides_title_en"
                      value={params?.section_2?.relation_guides_title_en || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <h5 className="fw-bold mb-5 mt-5">Data</h5>
                  </Grid>
                  {params?.section_2?.list?.map((item, index) => (
                    <>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="relation_guides_title_id"
                          className="mb-4"
                        >
                          Teks [ID]
                          <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="title_id"
                          placeholder="Teks"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChangeListSection2(e, index)}
                          type="text"
                          name="title_id"
                          value={item.title_id || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan Teks terlebih dahulu"]}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <InputLabel htmlFor="title_en" className="mb-4">
                        Teks [EN] <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="title_en"
                          placeholder="Teks"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChangeListSection2(e, index)}
                          type="text"
                          name="title_en"
                          value={item.title_en || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan Teks terlebih dahulu"]}
                        />
                      </Grid>
                      {index + 1 === params?.section_2?.list?.length ? (
                        <Grid item xs={1}>
                          <IconButton
                            aria-label="trash"
                            color="danger"
                            className="mt-9 bg-error text-white"
                            onClick={() => deleteListSection2(item.idx)}
                          >
                            <DeleteRounded fontSize="small" />
                          </IconButton>
                          <IconButton
                            aria-label="trash"
                            className="mt-9 bg-secondary text-white"
                            onClick={addListSection2}
                          >
                            <AddRounded fontSize="small" />
                          </IconButton>
                        </Grid>
                      ) : (
                        <Grid item xs={1}>
                          <IconButton
                            aria-label="trash"
                            color="danger"
                            className="mt-9 bg-error text-white"
                            onClick={() => deleteListSection2(item.idx)}
                          >
                            <DeleteRounded fontSize="small" />
                          </IconButton>
                        </Grid>
                      )}
                    </>
                  ))}
                </Grid>

                <h4 className="fw-bold mb-5 mt-10">Bagian 3 <IconButton onClick={() => setShowPreviewSec("/assets/images/illustrations/gcg_3.png")} size='small'><VisibilityOutlined fontSize='small' color='action'></VisibilityOutlined></IconButton></h4>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <UploadImage
                      uploadFoto={handleChangeFotoSection3}
                      label="Unggah Foto"
                      preview={params?.section_3?.img_preview}
                      required={true}
                      aspectRatio={682 / 558}
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 682 x 558",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="relation_principle_title_id"
                      className="mb-4"
                    >
                      Judul [ID] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="relation_principle_title_id"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChangeSection3}
                      type="text"
                      name="relation_principle_title_id"
                      value={
                        params?.section_3?.relation_principle_title_id || ""
                      }
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="relation_principle_title_en"
                      className="mb-4"
                    >
                      Judul [EN] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="relation_principle_title_en"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChangeSection3}
                      type="text"
                      name="relation_principle_title_en"
                      value={
                        params?.section_3?.relation_principle_title_en || ""
                      }
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <h5 className="fw-bold mb-5 mt-5">Data</h5>
                  </Grid>
                  {params?.section_3?.list?.map((item, index) => (
                    <>
                      <Grid item xs={6}>
                        <InputLabel htmlFor="title_id" className="mb-4">
                          Teks [ID]
                          <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="title_id"
                          placeholder="Teks"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChangeListSection3(e, index)}
                          type="text"
                          name="title_id"
                          value={item.title_id || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan Teks terlebih dahulu"]}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <InputLabel htmlFor="title_en" className="mb-4">
                        Teks [EN] <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="title_en"
                          placeholder="Teks"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChangeListSection3(e, index)}
                          type="text"
                          name="title_en"
                          value={item.title_en || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan Teks terlebih dahulu"]}
                        />
                      </Grid>
                      {index + 1 === params?.section_3?.list?.length ? (
                        <Grid item xs={1}>
                          <IconButton
                            aria-label="trash"
                            color="danger"
                            className="mt-9 bg-error text-white"
                            onClick={() => deleteListSection3(item.idx)}
                          >
                            <DeleteRounded fontSize="small" />
                          </IconButton>
                          <IconButton
                            aria-label="trash"
                            className="mt-9 bg-secondary text-white"
                            onClick={addListSection3}
                          >
                            <AddRounded fontSize="small" />
                          </IconButton>
                        </Grid>
                      ) : (
                        <Grid item xs={1}>
                          <IconButton
                            aria-label="trash"
                            color="danger"
                            className="mt-9 bg-error text-white"
                            onClick={() => deleteListSection3(item.idx)}
                          >
                            <DeleteRounded fontSize="small" />
                          </IconButton>
                        </Grid>
                      )}
                    </>
                  ))}
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="flex-end"
                    className="flex-column-reverse flex-md-row mt-20"
                  >
                    <Grid item xs={12} md={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="text-white w-full radius-6 text-capitalize py-2"
                        disableElevation
                        disabled={submit}
                      >
                        {submit ? (
                          <CircularProgress color="primary" size={25} />
                        ) : (
                          "Simpan Data"
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
          </Card>
        </Grid>
      </Grid>
      <ModalPreviewSec handleClose={() => setShowPreviewSec(null)} img={showPreviewSec} open={showPreviewSec} />
    </div>
  );
};

export default Konten;
